/**
 * @generated SignedSource<<a8d1ca2773496946ee8ed6b0ee2b6e05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeRoleOverview_widget$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverviewContent_widget">;
  readonly " $fragmentType": "WidgetEmployeeRoleOverview_widget";
};
export type WidgetEmployeeRoleOverview_widget$key = {
  readonly " $data"?: WidgetEmployeeRoleOverview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverview_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeRoleOverview_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetEmployeeRoleOverviewContent_widget"
    }
  ],
  "type": "WidgetEmployeeRoleOverview",
  "abstractKey": null
};

(node as any).hash = "ff1793327b138d54991686b38e5663cb";

export default node;
